import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ValidatePaymentResponse } from "../../models/response/validate-payment-response";
import { PaymentStatusResponse } from "../../models/response/payment-status-response";
import { PaymentListResponse } from "../../models/response/payment-list-response";
import { PaymentRequestListResponse } from "../../models/response/payment-request-list-response";

interface PaymentState {
  response: ValidatePaymentResponse | null;
  loading: boolean;
  error: string | null;
  payment_list: any;
  pagination: any;
  paymentStatusResponse: any;
}

const initialState: PaymentState = {
  response: null,
  loading: false,
  error: null,
  payment_list: [],
  pagination: null,
  paymentStatusResponse: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    submitPaymentRequestTokenValidationRequest(
      state,
      action: PayloadAction<any>,
    ) {
      state.loading = true;
    },
    submitPaymentValidationSuccess(
      state,
      action: PayloadAction<ValidatePaymentResponse>,
    ) {
      state.loading = false;
      state.response = action.payload;
    },
    submitPaymentValidationFailure(state, action: PayloadAction<any>) {
      state.loading = false;
    },
    fetchPaymentStatusRequest(state, action: PayloadAction<any>) {
      state.loading = true;
    },
    fetchPaymentStatusSuccess(
      state,
      action: PayloadAction<PaymentStatusResponse>,
    ) {
      state.loading = false;
      state.paymentStatusResponse = action.payload;
    },
    fetchPaymentStatusFailure(state, action: PayloadAction<any>) {
      state.loading = false;
    },
    fetchPaymentListRequest(state, action: PayloadAction<any>) {
      state.loading = true;
    },
    fetchPaymentListSuccess(state, action: PayloadAction<PaymentListResponse>) {
      state.loading = false;
      state.payment_list = action.payload?.body?.payments;
      state.pagination = action.payload?.body?.pagination;
    },
    fetchPaymentListFailure(state, action: PayloadAction<any>) {
      state.loading = false;
    },
    fetchPaymentRequestsListRequest(state, action: PayloadAction<any>) {
      state.loading = true;
    },
    fetchPaymentRequestsListSuccess(
      state,
      action: PayloadAction<PaymentRequestListResponse>,
    ) {
      state.loading = false;
      state.payment_list = action.payload?.body?.paymentRequests;
      state.pagination = action.payload?.body?.pagination;
    },
    fetchPaymentRequestsListFailure(state, action: PayloadAction<any>) {
      state.loading = false;
    },
  },
});

// Export actions
export const {
  submitPaymentRequestTokenValidationRequest,
  submitPaymentValidationSuccess,
  submitPaymentValidationFailure,
  fetchPaymentListRequest,
  fetchPaymentListSuccess,
  fetchPaymentListFailure,
  fetchPaymentRequestsListRequest,
  fetchPaymentRequestsListSuccess,
  fetchPaymentRequestsListFailure,
  fetchPaymentStatusRequest,
  fetchPaymentStatusSuccess,
  fetchPaymentStatusFailure,
} = paymentSlice.actions;

// Export reducer
export default paymentSlice.reducer;
